import Vue from 'vue';
import * as Msal from "msal";

const jwtDecode = require('jwt-decode');

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID || '',
    authority: process.env.VUE_APP_MSAL_AUTHORITY || '',
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URL || '',
    validateAuthority: true,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

const loginRequest = {
  scopes: [ "openid", "profile"  ],
};

var tokenRequest = {
  scopes: [ `api://${process.env.VUE_APP_MSAL_SCOPE_ID}/access_user` ],
};

const state = () => ({
  loggedIn: {},

  myMSALObj: null,
  
  // Silently login setup
  silentlyLoginTimeout: null,
  secondsBeforeSilentlyLogin: 120,
  killSilentlyAfterTimes: 3,
});

const getters = {
  isLoggedIn(state) {
    return state.loggedIn.authToken || false;
  },
  isAdmin(state) {
    return state.loggedIn.type === 'LhhpAdmin';
  },
};
  
const mutations = {
  logOut(state) {
    state.loggedIn = {};
    this.$sCache.clear('loggedIn');
  },

  setToken(state) {
    let loggedIn = {};
    if (typeof state.loggedIn.authToken === 'string') {
      return;
    }

    try {
      loggedIn = this.$sCache.get('loggedIn');
      if (loggedIn) {
        state.loggedIn = loggedIn;
        state.isLoggedIn = true;
      }
    } catch (err) {
      console.warn(err);

      // Silence is power...
      state.loggedIn = {};
    }
  },

  updateAuth(state, payload) {
    try {
      const decodedToken = jwtDecode(payload.authToken);
      console.log("Decoded token", decodedToken);

      const type = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

      const timeToExpire = decodedToken.exp - decodedToken.nbf;
      const expiresAt = this.$dayjs().add(timeToExpire, 'second');
      console.log("expiresAt", decodedToken.exp);

      payload.exp = expiresAt.format();
      payload.type = type;
      console.log("payload.exp", payload.exp);

      let tempAuth = {};
      Object.assign(tempAuth, state.loggedIn, payload);

      console.log("Assigned temp authentication", tempAuth);

      Vue.set(state, 'loggedIn', tempAuth);
      state.isLoggedIn = true;

      console.log("expiresAt.toDate", expiresAt.toDate());

      this.$sCache.set('loggedIn', state.loggedIn, expiresAt.toDate());
    } catch(err) {
      console.log(err);
      throw new Error(err);
    }
  },

  setSilentlyLoginTimeout(state, timeout) {
    state.silentlyLoginTimeout = timeout;
  },

  updateKillSilentlyAfterTimes(state) {
    state.killSilentlyAfterTimes--;
  },

  // Init MSAL
  initMsal(state) {
    if (!state.myMSALObj) {
      state.myMSALObj = new Msal.UserAgentApplication(msalConfig); // eslint-disable-line
    }
  },
};

const actions = {
  async login({ state, commit, dispatch }, payload) {
    console.log("Login Payload", payload);

    const doNotRedirect = payload.doNotRedirect || false;
    if (doNotRedirect) {
      payload.doNotRedirect = null;
    }

    try {
      commit('updateAuth', payload);

      if (doNotRedirect) {
        dispatch('silentlyLoginTimeout');
      }

      if (!doNotRedirect) {
        let goto = { name: 'home' };
        // If it is an admin, it goes to the admin dashboard
        if (state.loggedIn.roles[0] === 'LhhpAdmin') {
          goto = { name: 'admin-home' };
        }
        document.location = this.$router.resolve(goto).href;
      } else {
        console.log('Login Silently Works!');
      }
      return true;
    } catch (err) {
      this.$warning(`Oops! Something happened when loging you in, please try again,
if the problem persist contact the system administrator`);
      throw new Error(err);
    }
  },

  async startSession(ctx, user) {
    try {
      const response = await this.$axios.post('/authenticate', user);
      return response;
    } catch (err) {
      this.$warning('Please check your username and password');
      // this.$defaultResponseController(err);
      return false;
    }
  },

  /**
   * Execute Login Silently
   */
  async runLoginSilently({ state, commit, dispatch }) {
    console.log("Loging in silently");
    clearTimeout(state.silentlyLoginTimeout);

    try {
      const data = { refreshToken: state.loggedIn.authToken };
      const response = await this.$axios.post('Users/me/refresh-token', data);
      const newAuth = response.data;

      newAuth.doNotRedirect = true;

      await dispatch('login', newAuth);
      return `It looks like everything goes good!`;
    } catch (err) {
      console.log("Ops! something when wrong doing the silently login... trying again.");
      console.warn(err);

      if (state.killSilentlyAfterTimes > 0) {
        dispatch('silentlyLoginTimeout');
        commit('updateKillSilentlyAfterTimes');
      }
      throw new Error(err);
    }
  },

  /**
   * Set Silently Login Timeout
   */
  async silentlyLoginTimeout({ state, commit, dispatch }) {
    if (typeof state.loggedIn.exp !== 'undefined') {
      try {
        console.log("state.loggedIn.exp", state.loggedIn.exp);
        const expire_time = this.$dayjs(state.loggedIn.exp);
        console.log("expire_time", expire_time.format());
        const diff = expire_time.diff(this.$dayjs(), 'seconds');
        console.warn(`AUTOLOGIN IN: ${diff}`);
        if (diff > state.secondsBeforeSilentlyLogin) {
          if (state.silentlyLoginTimeout) {
            clearTimeout(state.silentlyLoginTimeout);
          }
          const tempTimeout = setTimeout(() => {
            dispatch('runLoginSilently');
          }, ((diff - state.secondsBeforeSilentlyLogin) * 1000));
          commit('setSilentlyLoginTimeout', tempTimeout);
        } else {
          dispatch('runLoginSilently');
        }
        return true;
      } catch (err) {
        console.warn(err);
        throw new Error(err);
      }
    }
  },


  async logOut({ state, commit }) {
    try {
      // TODO: Fully server side logout
      // await this.$axios.post('/logout', {});

      // Init SSO Library.
      if (state.loggedIn.type === 'LHhhpAdmin') {
        commit('initMsal');
        await state.myMSALObj.logout();
      }
    } catch (err) {
      // Silence is golden!
    }

    // Log the user out no matter what.
    this.$sCache.clear('loggedIn');
    document.location = this.$router.resolve({ name: 'login' }).href;
  },

  async sentResetPasswordEmail(ctx, payload) {
    try {
      await this.$axios.post('/Users/start-reset-password', payload);
      return true;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async emailConfirmation(ctx, token) {
    try {
      const ops = { headers: { "Authorization": `Bearer ${token}` }};
      const { data } = await this.$axios.put('/Users/EmailConfirmation', {}, ops);
      return data;
    } catch (err) {
      console.log(err);
      this.$defaultResponseController(err);
      return false;
    }
  },

  async sendConfirmationEmail(ctx, email) {
    try {
      await this.$axios.post('/Users/SendConfirmationEmail', {},
        { params: { emailaddress: email }});
      return true;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async validateToken(ctx, payload) {
    try {
      await this.$axios.get('/Users/validate-token', { params: payload });
      return true;
    } catch (err) {
      return false;
    }
  },

  async resetPassword(ctx, payload) {
    try {
      await this.$axios.put('/Users/reset-password', payload);
      return true;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  // Admin Login
  async adminSignIn({ state, dispatch }, returnToken) {
    try {
      await state.myMSALObj.loginPopup(loginRequest);
      if (state.myMSALObj.getAccount()) {
        if (returnToken) {
          return dispatch('adminGetToken');
        }
        return true;
      }
      this.$warning('Something happened trying to authenticate your request, you might not have permissions to sign-in as an administrator.');
      return false;
    } catch (err) {
      this.$warning(err.message);
      return false;
    }
  },

  async adminGetToken({ state, dispatch }) {
    if (state.myMSALObj.getAccount()) {
      try {
        const response = await state.myMSALObj.acquireTokenSilent(tokenRequest);
        return response.accessToken;
      } catch (err) {
        // Silently failed, let's try with a popup
        return await dispatch('adminGetTokenWithPopup');
      }
    } else {
      // TODO: No token acquired, need to log the user
      return dispatch('adminSignIn', true);
    }
  },

  async adminGetTokenWithPopup({ state }) {
    try {
      const response = await state.myMSALObj.acquireTokenPopup(tokenRequest);
      return response.accessToken;
    } catch (err) {
      this.$warning(err.message);
    }
  },

  // Do any call as vulcan!
  async vulcanAuthentication({ dispatch }, accessToken) {
    try {
      const { data } = await this.$axios.post('admin/authenticate', {}, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });
      if (data) {
        dispatch('login', data);
      }
      return true;
    } catch (err) {
      this.$warning(err.message);
      return false;
    }
  },
};


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};